import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { IconsModule } from '../../design/icons.module';
import { TooltipModule } from '../../directives/tooltip/tooltip.module';
import { ViewToggleComponent } from './view-toggle.component';

@NgModule({
  declarations: [ViewToggleComponent],
  imports: [CommonModule, IconsModule, TooltipModule],
  exports: [ViewToggleComponent]
})
export class ViewToggleModule { }
